import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Footer from '../core/Layout/Footer';
import image from '../img/bg5.jpg';

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundImage: `url(${image})`,
    backgroundSize: 'cover',
    backgroundPosition: 'top center',
    alignText: 'center',
    justifyContent: 'center',
    height: '50vh',
    width: '100%',
    color: 'white',
    paddingTop: '100px',
  },
  appBar: {
    height: '100px',
  },
  card: {
    alignContent: 'center',
    justifyContent: 'center',
  },
}));

export const Hub = () => {
  const classes = useStyles();
  return (
    <Grid>
      <Grid item className={classes.container}>
        <div className={classes.appBar} />
        <Grid container component="main" className={classes.card}></Grid>
      </Grid>
      {/*Footer*/}
      <Grid item sm={12}>
        <Footer />
      </Grid>
    </Grid>
  );
};
